import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { ModalController } from "@ionic/angular";
import { ProApproverDetailModel } from "src/app/model/ProApproverDetailModel";
import { ProApproverService } from "src/app/services/pro-approver.service";
// import { ViewPdfComponent } from "../view-pdf/view-pdf.component";
// import { ProRejectCaseComponent } from "./reject-case/pro-reject-case.component";
import {
  InAppBrowser,
  InAppBrowserEvent,
  InAppBrowserOptions,
} from "@awesome-cordova-plugins/in-app-browser/ngx";
import { ESignService } from "src/app/services/esign-service.service";
import { ApplicantDetailListModel } from "src/app/model/ApplicantDetailListModel";
// import { ProApproveCaseComponent } from "./approve-case/pro-approve-case.component";

@Component({
  selector: "app-secure-pro-approver",
  templateUrl: "./applicant-approver-dtl.component.html",
  styleUrls: ["./applicant-approver-dtl.component.scss"],
})
export class ApplicantApproverDtlComponent implements OnInit {
  isLoading: boolean = false;
  approverDetail: ApplicantDetailListModel;
  submitDisabled: boolean;
  applicationNo: number;
  verificationStatus: string;
  type: string;
  status: string;
  oldMaritalStatus: string;
  key: number;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private proApproverService: ProApproverService,
    private iab: InAppBrowser,
    private esignService: ESignService,
    private modalCtrl: ModalController,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.submitDisabled = false;
    this.route.params.subscribe((params: Params) => {
      this.key = +params["key"];
      this.applicationNo = +params["applicationNo"];
      this.type = params["type"];
      this.status = params["status"];
      this.oldMaritalStatus = params["oldMaritalStatus"];
      // if (this.type === "Photo") {
      //   this.router.navigate([
      //     "/applicant-approver-dtl/photo-upload",
      //     this.key,
      //   ]);
      // } else {
      //   this.router.navigate([
      //     "/applicant-approver-dtl/marriage-status",
      //     this.key,
      //   ]);
      // }

      // this.isLoading = true;
      // this.proApproverService
      //   .fetchApproverDetailByApplicationNo(this.applicationNo, this.type)
      //   .subscribe((data) => {
      //     this.approverDetail = data;
      //     this.isLoading = false;
      //   });
    });
  }

  //   async reject() {
  //     const modal = await this.modalCtrl.create({
  //       component: ProRejectCaseComponent,
  //       componentProps: {
  //         pan: this.proApproverDetail.pan,
  //         applicantName: this.proApproverDetail.applicantName,
  //       },
  //     });
  //     modal.present();

  //     const { data, role } = await modal.onWillDismiss();

  //     if (role === "reject") {
  //       this.onSubmit("REJECTED", data);
  //     }
  //   }

  //   async approve() {
  //     const modal = await this.modalCtrl.create({
  //       component: ProApproveCaseComponent,
  //       componentProps: {
  //         pan: this.proApproverDetail.pan,
  //         applicantName: this.proApproverDetail.applicantName,
  //       },
  //     });
  //     modal.present();

  //     const { data, role } = await modal.onWillDismiss();

  //     if (role === "approve") {
  //       this.onSubmit("APPROVED", null, data);
  //     }
  //   }

  //   onSubmit(
  //     verificationType: string,
  //     rejectReason?: string,
  //     outwardNo?: string
  //   ) {
  //     this.isLoading = true;
  //     this.submitDisabled = true;
  //     this.proApproverService
  //       .submitVerificationDetail(
  //         this.certJournalistKey,
  //         verificationType,
  //         rejectReason,
  //         outwardNo
  //       )
  //       .subscribe(
  //         (data) => {
  //           if (data.status === "SUCCESS") {
  //             if (verificationType === "APPROVED") {
  //               let url = data?.url;
  //               let target = "";
  //               let options: InAppBrowserOptions = {
  //                 zoom: "no",
  //                 hideurlbar: "yes",
  //                 toolbar: "no",
  //                 location: "no",
  //                 hidenavigationbuttons: "no",
  //                 usewkwebview: "yes",
  //               };
  //               if (localStorage.getItem("platform") == "ios") {
  //                 target = "_blank";
  //               } else {
  //                 target = "_self";
  //               }

  //               const browser = this.iab.create(url, target, options);
  //               browser.on("loadstart").subscribe((ev: InAppBrowserEvent) => {
  //                 console.log("onload stop--" + ev.url);
  //                 if (
  //                   ev.url.startsWith(
  //                     "http://localhost:8100/secure/verify-esign/PRO_APPROVAL"
  //                   ) ||
  //                   ev.url.startsWith(
  //                     "https://appdemo.mhada.gov.in/secure/verify-esign/PRO_APPROVAL"
  //                   ) ||
  //                   ev.url.startsWith(
  //                     "https://ihlms.mhada.gov.in/secure/verify-esign/PRO_APPROVAL"
  //                   )
  //                 ) {
  //                   this.isLoading = false;
  //                   browser.close();
  //                   this.isLoading = false;
  //                   this.router.navigate(
  //                     ["/secure", "verify-esign", "PRO_APPROVAL", data?.esignKey],
  //                     { replaceUrl: true }
  //                   );
  //                   window.location.reload();
  //                 }
  //               });
  //             } else {
  //               this.isLoading = false;
  //               this.proApproverService.successToast(
  //                 "Applicant with PAN - " +
  //                   this.proApproverDetail.pan +
  //                   " has been Rejected."
  //               );
  //               this.router.navigate(["/secure", "pro-approver-list"]);
  //             }
  //           } else {
  //             this.isLoading = false;
  //             this._snackBar.open(data.errorMessage, "Close", {
  //               horizontalPosition: "right",
  //               verticalPosition: "top",
  //               panelClass: "warning-toast",
  //               duration: 3 * 1000,
  //             });
  //             this.submitDisabled = false;
  //           }
  //         },
  //         (error) => {
  //           this.submitDisabled = false;
  //           this.isLoading = false;
  //           this._snackBar.open(error.errorMessage, "Close", {
  //             horizontalPosition: "right",
  //             verticalPosition: "top",
  //             panelClass: "warning-toast",
  //             duration: 3 * 1000,
  //           });
  //         }
  //       );
  //   }

  //   async viewEsignCertificate() {
  //     this.proApproverService
  //       .fetchEsignCertificate(this.certJournalistKey)
  //       .subscribe(async (data) => {
  //         if (data.status === "SUCCESS") {
  //           this.downloadFile(
  //             data.data,
  //             this.proApproverDetail?.pan +
  //               "_JR_CERTIFICATE_" +
  //               new Date().getTime() +
  //               ".pdf"
  //           );
  //         } else {
  //           this.proApproverService.errorToast(data.errorMessage);
  //         }
  //       });
  //   }

  downloadFile(base64: string | ArrayBuffer, fileName: string) {
    const src = `data:application/pdf;base64,${base64}`;
    const link = document.createElement("a");
    link.href = src;
    link.download = fileName;
    link.click();

    link.remove();
  }

  //   async viewFile(fileType, file) {
  //     const modal = await this.modalCtrl.create({
  //       component: ViewPdfComponent,
  //       componentProps: {
  //         base64: file,
  //         documentName: fileType,
  //         fileName:
  //           fileType +
  //           "_" +
  //           this.proApproverDetail?.pan +
  //           "_" +
  //           new Date().getTime() +
  //           ".pdf",
  //       },
  //     });
  //     modal.present();
  //   }
}
